"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AccommodationTypeDto {
}
exports.AccommodationTypeDto = AccommodationTypeDto;
class AccommodationTypeFeatureDto {
}
exports.AccommodationTypeFeatureDto = AccommodationTypeFeatureDto;
